import { useEffect, useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';

const ReferencesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [selectedProject, setSelectedProject] = useState<typeof projects[0] | null>(null);

  const projects = [
    {
      id: 1,
      title: 'Mutfak Tadilatı',
      location: 'İzmir',
      description: 'Modern ve fonksiyonel mutfak tasarımı ile hayalinizdeki mutfağa kavuşun',
      image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/5e86aa51edc71570490b4ff0a549d20c.jpeg',
    },
    {
      id: 2,
      title: 'Ofis Tadilatı',
      location: 'İzmir',
      description: 'Modern ve verimli çalışma alanı tasarımı',
      image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/6712f56f09a786a0542aad339bd5fa05.jpeg',
    },
    {
      id: 3,
      title: 'Kafe Tadilatı',
      location: 'İzmir',
      description: 'Eski ve yıpranmış kafeyi modern, aydınlık ve şık bir mekana dönüştürdük. Ahşap detaylar ve minimalist tasarımla müşterilerinize unutulmaz bir deneyim sunun.',
      image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/38ff0f3bdec26e922b657b1540f90b38.jpeg',
    },
    {
      id: 4,
      title: 'Banyo Tadilatı',
      location: 'İzmir',
      description: 'Eski ve yıpranmış banyonuzu modern, ferah ve şık bir mekana dönüştürüyoruz. LED aydınlatmalı ayna, cam duşakabin ve minimalist tasarımla banyonuz yepyeni bir görünüme kavuşuyor.',
      image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/afe44e3d59867c2ba1ec5d1bb83aa08a.jpeg',
    },
    {
      id: 5,
      title: 'Lobi Tadilatı',
      location: 'İzmir',
      description: 'Klasik ve karanlık lobi alanını modern, aydınlık ve şık bir mekana dönüştürdük. Yüksek tavanlar, doğal ışık ve minimalist mobilyalarla misafirlerinizi etkileyici bir atmosferde karşılayın.',
      image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/459b7792840d733cfb37080b84f6680c.jpeg',
    },
    {
      id: 6,
      title: 'Restoran Tadilatı',
      location: 'İzmir',
      description: 'Eski ve yıpranmış restoranı modern, aydınlık ve davetkar bir mekana dönüştürdük. Minimalist tasarım, ahşap zemin ve zarif aydınlatmalarla misafirlerinize keyifli bir yemek deneyimi sunun.',
      image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/e1d924d57b346913c259df5d8a3f7da5.jpeg',
    },
    {
      id: 7,
      title: 'Türk Hamamı Dönüşümü',
      location: 'İzmir',
      description: 'Standart banyoyu otantik Türk hamamı konseptine dönüştürdük. Mermer göbek taşı, kubbe tavan, sıcak-soğuk su sistemleri ve geleneksel hamam atmosferiyle evinizde spa deneyimi yaşayın.',
      image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/5eb918456acbc1278c4d74df64e70575.jpeg',
    },
    {
      id: 8,
      title: 'Komple Daire Tadilatı',
      location: 'İzmir',
      description: 'Eski ve karanlık daireyi modern, aydınlık ve ferah bir yaşam alanına dönüştürdük. Açık mutfak konsepti, mermer tezgah, minimalist mobilyalar ve doğal ışık ile eviniz yepyeni bir görünüme kavuşuyor.',
      image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/cc5c9f8e3a2637f6e1264233c40b1838.jpeg',
    },
  ];

  return (
    <div className="bg-cream">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-wood-dark">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mt-4 mb-6 leading-tight">
                Referanslarımız
              </h1>
              <p className="text-base md:text-xl text-white/90 leading-relaxed">
                <strong>İzmir tadilat firması</strong> olarak tamamladığımız projelerden örnekler
              </p>
            </div>
          </div>
        </section>

        {/* Projects Grid */}
        <section className="py-16 md:py-24">
          <div className="container mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {projects.map((project) => (
                <article key={project.id} className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group">
                  {/* Project Image */}
                  <div 
                    className="relative overflow-hidden cursor-pointer"
                    onClick={() => project.image && setSelectedProject(project)}
                  >
                    <div className="w-full h-72 bg-gray-200 flex items-center justify-center">
                      {project.image ? (
                        <img
                          src={project.image}
                          alt={`${project.title} - İzmir tadilat`}
                          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                          loading="lazy"
                        />
                      ) : (
                        <span className="text-gray-400 text-sm">Proje Görseli</span>
                      )}
                    </div>
                    {project.image && (
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                        <i className="ri-zoom-in-line text-white text-4xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                      </div>
                    )}
                  </div>

                  {/* Project Info */}
                  <div className="p-6">
                    <h3 className="text-xl md:text-2xl font-serif font-bold text-wood-dark mb-3 leading-tight">
                      {project.title}
                    </h3>
                    <div className="flex items-center text-sm text-wood/80 mb-3">
                      <i className="ri-map-pin-line mr-2"></i>
                      <span>{project.location}</span>
                    </div>
                    <p className="text-sm text-wood/80 leading-relaxed">
                      {project.description}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 md:py-24 bg-wood-dark">
          <div className="container mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-white mb-6 leading-tight">
              Siz de Hayalinizdeki Mekanı Yaratın
            </h2>
            <p className="text-base md:text-xl text-white/90 mb-8 md:mb-10 max-w-2xl mx-auto">
              <strong>İzmir anahtar teslim tadilat</strong> hizmetlerimiz için ücretsiz keşif ve fiyat teklifi alın
            </p>
            <div className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-4">
              <a
                href="tel:05421138110"
                className="w-full sm:w-auto px-6 md:px-8 py-3 md:py-4 bg-white hover:bg-beige text-wood-dark rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                Hemen Ara: 0542 113 81 10
              </a>
              <a
                href="https://wa.me/905421138110?text=Merhaba%2C%20izmirtadilatfirmasi.com%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum.%0ATadilat%2C%20dekorasyon%20ve%20i%C3%A7%20mimarl%C4%B1k%20hizmetleriniz%20hakk%C4%B1nda%20bilgi%20ve%20fiyat%20teklifi%20almak%20istiyorum."
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto px-6 md:px-8 py-3 md:py-4 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                WhatsApp ile Yaz
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <FloatingButtons />

      {/* Image Modal */}
      {selectedProject && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedProject(null)}
        >
          <div className="relative max-w-6xl w-full">
            {/* Close Button */}
            <button
              onClick={() => setSelectedProject(null)}
              className="absolute -top-12 right-0 text-white hover:text-beige transition-colors duration-300 cursor-pointer"
              aria-label="Kapat"
            >
              <i className="ri-close-line text-4xl"></i>
            </button>

            {/* Image */}
            <div className="bg-white rounded-2xl overflow-hidden">
              <img
                src={selectedProject.image}
                alt={`${selectedProject.title} - İzmir tadilat`}
                className="w-full h-auto max-h-[80vh] object-contain"
              />
              
              {/* Project Info */}
              <div className="p-6 bg-white">
                <h3 className="text-2xl md:text-3xl font-serif font-bold text-wood-dark mb-2">
                  {selectedProject.title}
                </h3>
                <div className="flex items-center text-sm text-wood/80 mb-3">
                  <i className="ri-map-pin-line mr-2"></i>
                  <span>{selectedProject.location}</span>
                </div>
                <p className="text-base text-wood/80">
                  {selectedProject.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReferencesPage;
